import * as THREE from 'three'
import Experience from "../Experience.js";
import anim from '../Utils/Anim.js';
import vertex from '../../shaders/darkIdea/vertex.glsl'
import fragment from '../../shaders/darkIdea/fragment.glsl'

export default class Tableau4 {
    constructor(_options) {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.ressources = this.experience.ressources
        this.time = this.experience.time
        // 
        this.isDestroyed = false
        this.targetPos = _options.targetPos


        this.setDarkIdea()
        this.mesh.visible = false
        requestAnimationFrame(() => {
            if (!this.isDestroyed) {
                this.appearTimeout = setTimeout(() => {

                    if (!this.isDestroyed) {
                        this.material.uniforms.u_appear.value = 0
                        this.mesh.visible = true

                        anim.to(this.material.uniforms.u_appear, {
                            value: 1,
                            duration: 1
                        })
                    }
                }, 1000)

            }
        });


    }
    setDarkIdea() {
        this.geometry = new THREE.PlaneGeometry(1, 1)
        this.material = new THREE.ShaderMaterial({
            transparent: true,
            depthTest: false,
            depthWrite: false,
            vertexShader: vertex,
            fragmentShader: fragment,
            uniforms: {
                u_res: new THREE.Uniform(new THREE.Vector2(this.experience.sizes.width, this.experience.sizes.height)),
                u_time: new THREE.Uniform(0),
                u_appear: new THREE.Uniform(0),
            }

        })
        this.material.uniforms.u_appear.value = 0
        this.mesh = new THREE.Mesh(this.geometry, this.material)
        this.mesh.rotation.y = Math.PI * 0.5
        this.mesh.rotation.x = Math.PI * 0.5
        this.mesh.lookAt(this.experience.camera.instance.position)
        this.mesh.position.set(this.targetPos.x - 5, this.targetPos.y, this.targetPos.z - 0.15)
        const distanceToCam = 16
        const fov = this.experience.camera.instance.fov * Math.PI / 180
        const scaleY = 2 * Math.tan(fov / 2) * distanceToCam
        const scaleX = scaleY * this.experience.sizes.width / this.experience.sizes.height
        this.mesh.scale.y = scaleY
        this.mesh.scale.x = scaleX
        // enable bloom on the mesh ? :
        this.mesh.layers.enable(1)
        this.scene.add(this.mesh)
    }

    destroy() {
        if (this.isDestroyed) return

        if (this.appearTimeout) {
            clearTimeout(this.appearTimeout)
        }
        anim.to(this.material.uniforms.u_appear, {
            value: 0,
            duration: 1,
            onComplete: () => {
                if (this.mesh) {

                    this.isDestroyed = true
                    this.scene.remove(this.mesh)
                    this.geometry.dispose()
                    this.material.dispose()
                    this.mesh = null
                    this.geometry = null
                    this.material = null
                }
            }
        })
    }


    resize() {
        if (!this.isDestroyed) {
            this.material.uniforms.u_res.value.set(this.experience.sizes.width, this.experience.sizes.height)
            // resize mesh 
            const distanceToCam = 16
            const fov = this.experience.camera.instance.fov
            const scaleY = 2 * Math.tan(fov) * distanceToCam
            const scaleX = scaleY * this.experience.sizes.width / this.experience.sizes.height
            this.mesh.scale.y = scaleY
            this.mesh.scale.x = scaleX
        }

    }
    update() {
        if (!this.isDestroyed) {
            this.mesh.position.set(this.targetPos.x - 5, this.targetPos.y, this.targetPos.z - 0.15)
            this.mesh.lookAt(this.experience.camera.instance.position)
            this.material.uniforms.u_time.value = this.experience.time.elapsed * 0.001
            const distanceToCam = 16
            const fov = this.experience.camera.instance.fov * Math.PI / 180
            const scaleY = 2 * Math.tan(fov / 2) * distanceToCam
            const scaleX = scaleY * this.experience.sizes.width / this.experience.sizes.height
            this.mesh.scale.y = scaleY
            this.mesh.scale.x = scaleX


        }


    }
}